<template>
  <div class="wp">
    <div
      class="img-wrap"
      @click="showPhotoSwipe()"
      @touchstart="touchstart"
      @touchend="touchend"
      ref="area"
    >
      <img :src="src" :limitTranslation="false" class="view" />
      <img
        v-if="!loaded"
        ref="img"
        :src="src"
        @load="loadedImgs"
        class="loadImg"
      />
    </div>
    <!--
    <v-photoswipe :isOpen="isOpen" :items="items" :options="options" @close="hidePhotoSwipe"></v-photoswipe>
    -->
    <!--
    <div style="position: absolute; top:0; left: 0; background: rgba(255, 255, 255, 0.8);">
      {{height}} {{zoom}} 
    </div>
    -->
  </div>
</template>

<script>
/* eslint-disable no-console */
// import { PhotoSwipe } from 'v-photoswipe'

export default {
  name: "ImgSwipe",
  props: {
    src: String,
    hasOption: Boolean
  },
  /*
  components: {
    'v-photoswipe' :PhotoSwipe
  },
  */
  data() {
    return {
      isOpen: false,
      options: {
        index: 0,
        shareEl: false
      },
      items: [],
      loaded: false,
      zoom: 1,
      height: 0,

      queue: 0
    };
  },
  mounted() {
    console.log("mounted");
    window.addEventListener("resize", this.reload);
  },
  methods: {
    reload() {
      this.$nextTick(() => {
        clearTimeout(this.queue);

        this.queue = setTimeout(() => {
          console.log("resize");
          this.items = [];
          this.loaded = false;
        }, 300);
      });
    },
    touchstart(e) {
      //e.stopPropagation();
      let point;
      if (e.touches) {
        point = e.changedTouches[0];
      } else {
        point = e;
      }

      this.initPosition = { x: point.pageX, y: point.pageY };
    },
    touchend(e) {
      let point;
      if (e.touches) {
        point = e.changedTouches[0];
      } else {
        point = e;
      }

      this.position = point.pageY - this.initPosition.y;
      if (this.position === 0) {
        // this.showPhotoSwipe();
      }
    },
    showPhotoSwipe() {
      // this.isOpen = true;
    },
    hidePhotoSwipe() {
      this.isOpen = false;
    },
    loadedImgs() {
      if (this.$refs.img) {
        this.items.push({
          src: this.src,
          w: this.$refs.img.width,
          h: this.$refs.img.height,
          title: ""
        });

        this.zoom =
          Math.floor(
            (this.$refs.area.clientWidth / this.$refs.img.width) * 1000
          ) / 1000;
        let optionBlockSize = this.hasOption ? 70 : 0;
        this.height =
          Math.max(
            Math.ceil(this.$refs.img.height * this.zoom),
            Math.floor(this.$refs.img.height * this.zoom)
          ) + optionBlockSize;

        this.$nextTick(() => {
          console.log("img loaded");
          console.log(this.src);
          this.loaded = true;

          /*
          if (this.height >= window.innerHeight - 200) {
            if (window.innerHeight > window.innerWidth) {
              this.$emit("blockSize", "calc(100% - " + optionBlockSize + " )");
            } else {
              this.$emit("blockSize", window.innerHeight - 200 - optionBlockSize + "px");
            }
          } else {
            this.$emit("blockSize", this.height + "px");
          }
          */


          const areaHeight = Math.max(window.innerHeight, document.querySelector('.input-container').clientHeight)

          const enoughHeight = areaHeight > 600;

          if (
            window.innerWidth > window.innerHeight &&
            this.height >= areaHeight - 170
          ) {
            if (enoughHeight) {
              this.$emit(
                "blockSize",
                (areaHeight - 170) - optionBlockSize + "px"
              );
            } else {
              this.$emit(
                "blockSize",
                areaHeight - 170 + "px"
              );
            }
          } else {
            if (this.height >= (areaHeight - 170)) {
              this.$emit("blockSize", (areaHeight - 170) + "px");
            } else {
              this.$emit("blockSize", this.height + "px");
            }
          }

          this.$nextTick(() => {
            console.log(this.$refs.area.clientHeight, this.height);
            if (this.height === this.$refs.area.clientHeight) {
              this.$emit("blockSize", this.height + 32 + "px");
            }
          });
        });
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.wp {
  overflow: hidden;
}

div.img-wrap {
  width: 100%;
  height: 100%;

  overflow: auto;
}

img.view {
  margin: 0 auto;
  width: 100%;
  pointer-events: none;
  object-fit: contain;
}

.loadImg {
  position: absolute;
  top: 0;
  left: 0;
}
</style>
